import { SignupContext } from './SignupContext';

interface SignupProviderProps {
  children: React.ReactNode;
  email: string;
  setEmail: (email: string) => void;
  onEmailChange?: (email: string) => void;
  isSubmitting: boolean;
  autoFocus: boolean;
}

export const SignupProvider: React.FC<SignupProviderProps> = ({
  children,
  email,
  setEmail,
  onEmailChange,
  isSubmitting,
  autoFocus,
}) => {
  return (
    <SignupContext.Provider
      value={{
        email,
        setEmail,
        onEmailChange,
        isSubmitting,
        autoFocus,
      }}
    >
      {children}
    </SignupContext.Provider>
  );
};
